import axios from 'axios';

const client = axios.create({
  baseURL: '',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor for error handling
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect if already on auth pages or if this is an auth check
      const isAuthCheck = error.config?.url?.includes('/auth/me');
      const isAuthPage = ['/login', '/pending-approval'].includes(window.location.pathname);

      if (!isAuthCheck && !isAuthPage) {
        // Redirect to login on unauthorized
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default client;
